import { createContext, useContext } from 'react';

export interface ModalContextValue {
  /**
   * Modal의 z-index 값
   * Modal 내부의 Dropdown 등이 이 값을 참조하여 자동으로 더 높은 z-index를 설정할 수 있습니다.
   */
  zIndex: number;
}

export const ModalContext = createContext<ModalContextValue | null>(null);

/**
 * Modal 내부에서 사용되는 컴포넌트가 Modal의 z-index를 참조할 수 있도록 합니다.
 * Modal 외부에서 사용될 경우 null을 반환합니다.
 */
export const useModalContext = () => {
  return useContext(ModalContext);
};
